import * as React from "react";
const IconSquarePollHorizontal = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56 3H8C5.2 3 3 5.2 3 8v48c0 2.8 2.2 5 5 5h48c2.8 0 5-2.2 5-5V8c0-2.8-2.2-5-5-5m3 53c0 1.7-1.3 3-3 3H8c-1.7 0-3-1.3-3-3V8c0-1.7 1.3-3 3-3h48c1.7 0 3 1.3 3 3z" />
    <path d="M13.5 17.4h15.3c.6 0 1-.4 1-1s-.4-1-1-1H13.5c-.6 0-1 .4-1 1s.5 1 1 1M44.5 31h-31c-.6 0-1 .4-1 1s.4 1 1 1h31c.6 0 1-.4 1-1s-.4-1-1-1M36 46.6H13.5c-.6 0-1 .4-1 1s.4 1 1 1H36c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconSquarePollHorizontal;
